export interface IBranchToolsAuthorizationConfig {
    isAAPayloadXMLSimulator: string
    isXMLAuditor: string
}

export const BranchToolsPrevilages = () => {
    const BranchTools: IBranchToolsAuthorizationConfig = {
        isAAPayloadXMLSimulator: 'Enabled',
        isXMLAuditor: 'Enabled'
    }

    const adminHashMap = new Map<string, IBranchToolsAuthorizationConfig>()
    adminHashMap.set('BranchToolsPrevilages', BranchTools)

    return adminHashMap
}

export const defaultBranchTools: IBranchToolsAuthorizationConfig = {
    isAAPayloadXMLSimulator: 'Disabled',
    isXMLAuditor: 'Disabled'
}
